import { render, staticRenderFns } from "./FlowArea.vue?vue&type=template&id=7df51ddb&"
import script from "./FlowArea.vue?vue&type=script&lang=js&"
export * from "./FlowArea.vue?vue&type=script&lang=js&"
import style0 from "./FlowArea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports